import React from 'react';

import { Box } from '@rbilabs/components-library';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { usePaymentContext } from 'state/payment';

import { PlaceOrderText } from './place-order-text';
import { IPlaceOrderButtonProps } from './types';

export const OverrideActionButton = styled(ActionButton)`
  padding: 0.75rem;

  svg path {
    fill: ${p => p.theme.token('text-button-primary')};
  }
`;

const PlaceOrderButton: React.FC<IPlaceOrderButtonProps> = ({
  placeOrderAriaLabel,
  reloadAmount,
  disabled,
  onClick,
  isLoading,
  confirmation: confirmationValue,
  margin = '1rem 0 0',
}) => {
  /**
   * If payment processor is VR payment, we need to reverse the value of confirmation
   * since we are not placing an order directly from the store confirmation modal.
   * Hence, the button text must be "continue" when confirmation is true.
   */
  const { isHostedPage } = usePaymentContext();
  let confirmation = confirmationValue;
  if (isHostedPage) {
    confirmation = !confirmationValue;
  }

  return (
    <Box margin={margin}>
      <OverrideActionButton
        fullWidth
        onClick={onClick}
        aria-label={confirmation ? placeOrderAriaLabel : undefined}
        data-testid={confirmation ? 'place-order' : 'continue-order'}
        disabled={disabled}
        isLoading={isLoading}
      >
        <PlaceOrderText reloadAmount={reloadAmount} confirmation={confirmation} />
      </OverrideActionButton>
    </Box>
  );
};

export default PlaceOrderButton;
